import { Link } from "react-router-dom";
import { useSiteLang } from "../lib/siteLang";

const linkClass = "inline-block py-2.5 text-sm text-white/70 hover:text-white transition-colors";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useSiteLang();

  return (
    <footer className="py-12 bg-[#09101F] border-t border-white/10" data-testid="footer">
      <div className="max-w-6xl mx-auto px-5 md:px-10 grid gap-10 md:grid-cols-[1.2fr_1fr_1fr]">
        <div>
          <Link to="/" className="inline-flex items-center gap-3" data-testid="footer-logo">
            <img src="/images/logo-192.png" alt="GozzoGuide" className="h-10 w-10 rounded-xl object-cover" />
            <span className="font-bold text-lg text-[#FF6B00] tracking-tight">GozzoGuide</span>
          </Link>
          <p className="mt-4 text-sm text-white/70 max-w-xs">{t.tagline}</p>
          <p className="mt-6 text-sm text-white/50" data-testid="footer-copyright">
            © {currentYear} GozzoGuide. {t.rights}
          </p>
        </div>

        <nav aria-label={t.footerSite}>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/50 mb-4">{t.footerSite}</p>
          <ul className="space-y-3">
            <li><Link to="/privacy" className={linkClass} data-testid="footer-privacy-link">{t.privacy}</Link></li>
            <li><Link to="/terms" className={linkClass} data-testid="footer-terms-link">{t.terms}</Link></li>
            <li><Link to="/cookie" className={linkClass} data-testid="footer-cookie-link">{t.cookies}</Link></li>
          </ul>
        </nav>

        <nav aria-label={t.footerApp}>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/50 mb-4">{t.footerApp}</p>
          <ul className="space-y-3">
            <li><Link to="/app-privacy" className={linkClass} data-testid="footer-app-privacy-link">{t.appPrivacy}</Link></li>
            <li><Link to="/app-terms" className={linkClass} data-testid="footer-app-terms-link">{t.appTerms}</Link></li>
            <li><Link to="/app-cookie" className={linkClass} data-testid="footer-app-cookie-link">{t.appCookies}</Link></li>
            <li><Link to="/delete-account" className={linkClass} data-testid="footer-delete-account-link">{t.deleteAccount}</Link></li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};
